import { FC } from "react";

import { IRideTableDto, RideStartStatusEnum } from "@ryde/shared";

import { LiveMapRideStartStatusBadge } from "../../grid/cell-templates/rides/live-map-ride-start-status-badge";
import { IRenderColumnTemplate } from "./_core";

export const LiveMapRideStartStatusCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
  value,
}) => {
  const ride = rowOriginal as IRideTableDto | undefined;
  // `value` is "" (not undefined) for rows without data — `||` so the fallback chain still runs.
  const status =
    (value as RideStartStatusEnum | "" | undefined) ||
    ride?.realStatusRideStartByGps ||
    undefined;

  return <LiveMapRideStartStatusBadge status={status} />;
};
